import { render, staticRenderFns } from "./RegisterAsBidderButton.vue?vue&type=template&id=6b768622&scoped=true&"
import script from "./RegisterAsBidderButton.vue?vue&type=script&lang=js&"
export * from "./RegisterAsBidderButton.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAsBidderButton.vue?vue&type=style&index=0&id=6b768622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b768622",
  null
  
)

export default component.exports